import { makeRequest } from "./api";

export const FetchBedTypes = async () => {
  return makeRequest("/api/admin/bedType/fetch");
};

export const CreateBedType = async (itemName, status) => {
  return makeRequest("/api/admin/bedType/create", {
    method: "POST",
    data: {
      itemName,
      status,
    },
  });
};

export const UpdateBedType = async (bedTypeId, itemName, status) => {
  return makeRequest(`/api/admin/bedType/update`, {
    method: "PUT",
    data: {
      bedTypeId,
      itemName,
      status,
    },
  });
};

export const DeleteBedType = async (bedTypeId) => {
  return makeRequest(`/api/admin/bedType/remove/${bedTypeId}`, {
    method: "DELETE",
    data: {
      data: {
        bedTypeId: bedTypeId,
      },
    },
  });
};
